import { EventEmitter } from '@angular/core';
import { ReportSectionEnum } from '../../../../../models/measure/report';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
import { defaultPlatformSettings } from '../../../../app.constants';
var TextData;
(function (TextData) {
    TextData["NA"] = "NA";
})(TextData || (TextData = {}));
var Vertical;
(function (Vertical) {
    Vertical[Vertical["Index"] = 2] = "Index";
})(Vertical || (Vertical = {}));
var ChannelOpportunitiesReportComponent = /** @class */ (function () {
    function ChannelOpportunitiesReportComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.changeSettingEvent = new EventEmitter();
        this.opportunityData = [];
    }
    ChannelOpportunitiesReportComponent.prototype.ngOnInit = function () {
        this.isNoData = false;
        if (this.data && this.data.length === 0) {
            this.isNoData = true;
            return;
        }
        // get industry list
        if (this.data) {
            this.industryList = this.data
                .map(function (channel, index) { return ({
                id: index,
                name: channel[Vertical.Index].verticalName
            }); })
                .filter(function (channel) { return channel.name !== TextData.NA; });
            if (this.industryIndex) {
                this.selectIndustry(this.industryIndex);
            }
            else if (this.industryList.length > 0) {
                this.industryIndex = this.industryList[0].id;
                this.selectIndustry(this.industryIndex);
            }
        }
    };
    ChannelOpportunitiesReportComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(ChannelOpportunitiesReportComponent.COMPONENT_NAME);
    };
    ChannelOpportunitiesReportComponent.prototype.selectIndustry = function (industryIndex) {
        if (industryIndex === null) {
            this.opportunityData = [];
        }
        else {
            this.opportunityData = this.data[industryIndex].slice(0, 2);
            this.changeSettingEvent.emit({
                reportType: ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT,
                value: industryIndex
            });
        }
    };
    // calculate percent and return if percent is bigger than 100
    ChannelOpportunitiesReportComponent.prototype.calculatePercent = function (percent) {
        return percent > 100 ? 100 : percent;
    };
    Object.defineProperty(ChannelOpportunitiesReportComponent.prototype, "isExportingPdfReport", {
        get: function () {
            return this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelOpportunitiesReportComponent.prototype, "reachLineColor", {
        get: function () {
            return defaultPlatformSettings.chartColors[1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelOpportunitiesReportComponent.prototype, "engageLineColor", {
        get: function () {
            return defaultPlatformSettings.chartColors[2];
        },
        enumerable: true,
        configurable: true
    });
    ChannelOpportunitiesReportComponent.COMPONENT_NAME = 'ChannelOpportunitiesReportComponent';
    return ChannelOpportunitiesReportComponent;
}());
export { ChannelOpportunitiesReportComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/channel-opportunities-report/channel-opportunities-report.component.ts.pre-build-optimizer.js